/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

const ArrayOfId = PropTypes.arrayOf(
  PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
);

export { ArrayOfId };
